import { createContext, useContext } from 'react';

import type { GaugeChartTooltipConfig } from '../slots/Tooltip.js';

const defaultValue: GaugeChartTooltipConfig = { hidden: false };

/**
 * @internal
 */
export const GaugeChartTooltipContext =
  createContext<GaugeChartTooltipConfig>(defaultValue);

/**
 * @internal
 */
export const useGaugeChartTooltip = () => useContext(GaugeChartTooltipContext);
